import { variables } from '../mpanels/variables';
import createMuiAlertStyles from './MuiAlert';
import createMuiCardStyles from './MuiCard';
import createMuiOutlinedInputStyles from './MuiOutlinedInput';
import createMuiPaperStyles from './MuiPaper';
import createMuiPopoverStyles from './MuiPopover';
import {
    createMuiTableCellStyles,
    createMuiTableHeadStyles,
    createMuiTableRowStyles,
} from './MuiTable';
import {
    createMuiStepStyles,
    createMuiStepIconStyles,
    createMuiStepLabelStyles,
    createMuiStepConnectorStyles,
} from './MuiStep';
import { createMuiTabPanelStyles, createMuiTabsStyles, createMuiTabStyles } from './MuiTab';
import createMuiDividerStyles from './MuiDivider';
import { createMuiPickersPopperStyles, createMuiPickersDayStyles } from './MuiPicker';
import createMuiChipStyles from './MuiChip';
import createMuiAutocompleteStyles from './MuiAutocomplete';
import createMuiSelectStyles from './MuiSelect';
import createMuiAccordionStyles from './MuiAccordion';
import { createMuiListStyles, createMuiListSubheaderStyles } from './MuiList';
import createMuiMenuStyles from './MuiMenu';
import createMuiMenuItemStyles from './MuiMenuItem';
import createMuiFormControlLabelStyles from './MuiFormControlLabel';
import createMuiCheckboxStyles from './MuiCheckbox';
import createMuiRadioStyles from './MuiRadio';
import createMuiTouchRipple from './MuiTouchRipple';
import createMuiFormHelperTextStyles from './MuiFormHelperText';
import createMuiSkeletonStyles from './MuiSkeleton';
import createMuiInputLabelStyles from './MuiInputLabel';
import createMuiTooltipStyles from './MuiTooltip';
import createMuiBackdropStyles from './MuiBackdrop';
import createMuiCssBaselineStyles from './MuiCssBaseline';

type Variables = typeof variables;

const sharedTheme = (variables: Variables) => ({
    MuiCssBaseline: createMuiCssBaselineStyles(),
    MuiAlert: createMuiAlertStyles(),
    MuiPopover: createMuiPopoverStyles(variables),
    MuiPaper: createMuiPaperStyles(variables),
    MuiOutlinedInput: createMuiOutlinedInputStyles(variables),
    MuiCard: createMuiCardStyles(variables),
    MuiTableHead: createMuiTableHeadStyles(),
    MuiTableCell: createMuiTableCellStyles(variables),
    MuiTableRow: createMuiTableRowStyles(variables),
    MuiStep: createMuiStepStyles(),
    MuiStepIcon: createMuiStepIconStyles(variables),
    MuiStepLabel: createMuiStepLabelStyles(variables),
    MuiStepConnector: createMuiStepConnectorStyles(),
    MuiTab: createMuiTabStyles(variables),
    MuiTabPanel: createMuiTabPanelStyles(),
    MuiTabs: createMuiTabsStyles(variables),
    MuiDivider: createMuiDividerStyles(variables),
    MuiPickersPopper: createMuiPickersPopperStyles(variables),
    MuiPickersDay: createMuiPickersDayStyles(variables),
    MuiChip: createMuiChipStyles(variables),
    MuiAutocomplete: createMuiAutocompleteStyles(variables),
    MuiSelect: createMuiSelectStyles(variables),
    MuiAccordion: createMuiAccordionStyles(variables),
    MuiList: createMuiListStyles(),
    MuiListSubheader: createMuiListSubheaderStyles(),
    MuiMenu: createMuiMenuStyles(),
    MuiMenuItem: createMuiMenuItemStyles(),
    MuiFormControlLabel: createMuiFormControlLabelStyles(variables),
    MuiCheckbox: createMuiCheckboxStyles(),
    MuiRadio: createMuiRadioStyles(),
    MuiTouchRipple: createMuiTouchRipple(),
    MuiFormHelperText: createMuiFormHelperTextStyles(variables),
    MuiSkeleton: createMuiSkeletonStyles(),
    MuiInputLabel: createMuiInputLabelStyles(variables),
    MuiTooltip: createMuiTooltipStyles(variables),
    MuiBackdrop: createMuiBackdropStyles(),
});

export default sharedTheme;
